import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type PortalUserFieldsFragment = { __typename?: 'PortalUserDocument', id: string, portalUserId: string, tenantId: string, customerId: string, email: string, firstName: string, lastName: string, role: string, status: number, userType: Types.UserType, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO };

export type GetPortalUsersQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.PortalUserDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.PortalUserDocumentSortInput> | Types.PortalUserDocumentSortInput>;
}>;


export type GetPortalUsersQuery = { __typename?: 'Query', customerPortalUsers?: { __typename?: 'CustomerPortalUsersConnection', totalCount: number, nodes?: Array<{ __typename?: 'PortalUserDocument', id: string, portalUserId: string, tenantId: string, customerId: string, email: string, firstName: string, lastName: string, role: string, status: number, userType: Types.UserType, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export const PortalUserFieldsFragmentDoc = new TypedDocumentString(`
    fragment PortalUserFields on PortalUserDocument {
  id
  portalUserId
  tenantId
  customerId
  email
  firstName
  lastName
  role
  status
  userType
  createdBy
  createdDate
  lastModified
}
    `, {"fragmentName":"PortalUserFields"});
export const GetPortalUsersDocument = new TypedDocumentString(`
    query GetPortalUsers($tenantId: String!, $first: Int, $after: String, $where: PortalUserDocumentFilterInput, $order: [PortalUserDocumentSortInput!]) {
  customerPortalUsers(
    tenantId: $tenantId
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...PortalUserFields
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    fragment PortalUserFields on PortalUserDocument {
  id
  portalUserId
  tenantId
  customerId
  email
  firstName
  lastName
  role
  status
  userType
  createdBy
  createdDate
  lastModified
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetPortalUsers: build.query<GetPortalUsersQuery, GetPortalUsersQueryVariables>({
      query: (variables) => ({ document: GetPortalUsersDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetPortalUsersQuery, useLazyGetPortalUsersQuery } = injectedRtkApi;
